import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { CommonExplainModule } from "../../../common-explain/common-explain.module";
import { SearchableEntityComponent } from "../searchable-entity/searchable-entity.component";
import { AssigneesPopoverComponent, LightTender } from "../assignees-popover/assignees-popover.component";
import { Tender } from '../../models/tender';

@Component({
  selector: 'app-tender-assignees',
  standalone: true,
  imports: [
    CommonExplainModule,
    SearchableEntityComponent,
    AssigneesPopoverComponent
  ],
  templateUrl: './tender-assignees.component.html',
  styleUrl: './tender-assignees.component.scss'
})
export class TenderAssigneesComponent {
  environment = environment;
  @Input({required: true}) tender!: Tender;
  @Input() assigneePopOverId?: string;
  @Output() toggleAssigneePopover = new EventEmitter<string>();
  @Output() closeAssigneePopover = new EventEmitter<void>();
  @Input() styleClass: 'regular' | 'dark' = 'regular';


  get hasMultipleAssignees(): boolean {
    return (this.tender.assignees?.length ?? 0) > 1;
  }

  get firstAssignee(): string {
    return this.tender.assignees?.[0] ?? '';
  }

  get remainingAssignees(): string[] {
    return this.tender.assignees?.slice(1) || [];
  }

  get assigneesData(): LightTender {
    return {
      id: this.tender.id,
      assignees: this.remainingAssignees
    };
  }

  toggleOverlay(id: string) {
    this.toggleAssigneePopover.emit(id);
  }

  closeOverlay() {
    this.closeAssigneePopover.emit();
  }
}
